<script>
  import Banner from "@/components/atoms/Banner";
  import OrderStatus from "@/components/atoms/OrderStatus";

  export default {
    components: { Banner, OrderStatus },
    computed: {
      ordersIds(){
        return this.$store.get('payment/ordersIds')
      },
    },
    methods: {
      loadOrder(id){
        this.$store.dispatch("payment/loadOrder", id).then(response => {
          this.$router.push({name: 'OrderFromHistory'})
        })
      }
    }
  }
</script>

<template>
  <Banner>
    <div id="order-history">
      <div class="limiter">
        <template v-if="ordersIds && ordersIds.length > 0">
          <div class="title">
            My Orders
          </div>
          <div v-for="id in ordersIds" :key="id" class="card" @click="() => loadOrder(id)">
            {{id}}
          </div>
        </template>
        <template v-else>
          <div class="title">
            You haven't placed any orders yet 😿
          </div>
        </template>
      </div>
    </div>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
#order-history { 
  display: flex;
  justify-content: center;
  align-items: stretch;
  min-height: 100%;
	.limiter { 
    flex-basis: 60rem;
    padding-top: 1rem;
    padding-bottom: 4rem;
    .title{
      font-size: 2rem;
      margin: 2rem 2rem 1.5rem 2rem;
    }
    .card {
      padding: 2rem;
      margin: 0.75rem;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      background-color: $card_background;
      box-shadow: $z_depth_2;
      transition: transform 0.3s ease;
      border-radius: 0.5rem;
      position: relative;
      font-size: 1.5rem;
      &:hover, &.hover{
        transform: scale(1.025);
        cursor: pointer;
        .grab-indicator{
          // opacity: 1;
        }
      }
      * {
        pointer-events: none;
      }
    }
	}
}
</style>